import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import ContractBasisDetails from '../ContractBasisDetails/ContractBasisDetails'

const ContractBasisCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <ContractBasisDetails
            onSuccess={onSuccess}
        />
    )
}

export default ContractBasisCreate
